<template>
  <div class="fixed-position">
    <el-menu 
            class="el-menu-demo" 
            :router=true
            mode="horizontal" 
            @select="handleSelect">
      <el-menu-item v-if="token" index="/patient/account/configuration">
        <i class="el-icon-s-tools"></i>
        <span>{{computeCaption('Account', $store.state.lang.value.toLowerCase())}}</span>
      </el-menu-item>
      <el-menu-item :index="token ? '/patient/account' : '/'">
        <i class="el-icon-s-home"></i>
        <span>{{computeCaption('Home', $store.state.lang.value.toLowerCase())}}</span>
      </el-menu-item>
      <el-menu-item v-if="token" index="/">
        <i class="el-icon-right"></i>
        <span>{{computeCaption('Log Out', $store.state.lang.value.toLowerCase())}}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import {MenuItem, Menu} from 'element-ui'
import {TranslationsUtils} from '../../../utils/Translations'
export default {
  mixins: [TranslationsUtils],
  components: {
    [MenuItem.name]: MenuItem,
    [Menu.name]: Menu
  },
  data () {
    return {
      token: localStorage.getItem('token')
    }
  },
  computed: {
  },
  methods: {
    handleSelect (key, keyPath) {
      if (key === '/') {
        this.logout()
      }
    },
    logout () {
      localStorage.clear()
    }
  }
}
</script>

<style scoped>
.fixed-position {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 200;
  right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Layout/Navbar.vue